/**
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business 評価ページルート。Coming Soon表示でエンジニア評価機能（開発中）のプレースホルダーを表示
 * @graph-connects none
 */
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Card } from '@cortex/web-design-system/components/ui/Card';
import { Button } from '@cortex/web-design-system/components/ui/Button';

/** @graph-connects none */
export const Route = createFileRoute('/evaluation')({
  component: EvaluationPage,
});

/** @graph-connects none */
function EvaluationPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6 animate-fade-in">
      {/* Page header */}
      <div>
        <h1 className="text-2xl font-bold text-[var(--color-text-primary)]">
          {t('nav.evaluation')}
        </h1>
        <p className="mt-1 text-[var(--color-text-secondary)]">エンジニア評価の実行と結果確認</p>
      </div>

      {/* Coming soon card */}
      <Card className="text-center py-12">
        <div className="w-16 h-16 rounded-full bg-[var(--color-accent-muted)] text-[var(--color-accent-primary)] flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-[var(--color-text-primary)]">Coming Soon</h2>
        <p className="mt-2 text-[var(--color-text-secondary)] max-w-md mx-auto">
          エンジニア評価機能は現在開発中です。評価の実行、プロンプト設定、結果の可視化などの機能を提供予定です。
        </p>
        <Button variant="secondary" className="mt-6">
          詳細を見る
        </Button>
      </Card>
    </div>
  );
}
